export const EXCLUDED_ATTRIBUTE_VALUES = [
  'Chiny',
  'Inne',
  'Čína',
  'Iné',
  'Čína',
  'Jiné',
  'China',
  'andere',
];

export const EXCLUDED_ATTRIBUTE_SLUGS = [
  'gdi_label',
  'products_urls',
  'creation_source',
  'force_update',
  'gpsr_producer_info',
  'gpsr_responsible_person',
  'locales_product_activity',
  'main_packshot_select',
  'import_flag',
  'creation_source',
  'last_full_update',
];
